module.exports = __webpack_public_path__ + "65e197b1ffe369186fc179b0e3986c7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/photo.jpg
// module id = 492
// module chunks = 0